import { useEvent } from "shared/lib/useEvent"
import { ProductConfigurationFormData } from "shared/types/ProductConfiguration"

import { ProductConfiguratorProps } from "../ProductConfigurator"
import { ProductConfiguratorAddonsViewModel } from "../ui/addons/ProductConfiguratorAddonsView"
import { useProductConfiguratorConfigurationContext } from "./ProductConfiguratorConfigurationContext"

export function useProductConfiguratorAddonsViewModel({
  addonOptions,
  onAddonDelete
}: Pick<
  ProductConfiguratorProps,
  "addonOptions" | "onAddonDelete"
>): ProductConfiguratorAddonsViewModel {
  const { formData, isLoading, isUpdating, isDisabled, onFormDataChange } =
    useProductConfiguratorConfigurationContext()

  const handleFormDataChange = useEvent(
    (nextFormData: ProductConfigurationFormData["addons"], fieldID?: string) =>
      onFormDataChange(
        { ...formData, addons: { ...formData?.addons, ...nextFormData } },
        fieldID
      )
  )

  return {
    addonOptions,

    isLoading,
    isDisabled,
    isUpdating,

    onChange: handleFormDataChange,
    onDelete: onAddonDelete
  }
}
